import { combineReducers, Reducer } from 'redux'
import { reconDataSummaryReducer } from './ReconAIDataQuality/store/reducers'
import { reconDataSummarySagas } from './ReconAIDataQuality/store/sagas'

export const modulesSagas = [...reconDataSummarySagas]

interface IModulesState {
  ReconAIDataQuality: ReturnType<typeof reconDataSummaryReducer>
  trust: any
}

export type StaticModulesState = IModulesState

export const modulesReducer: Reducer<any> = combineReducers({
  ReconAIDataQuality: reconDataSummaryReducer
})
